<template>
  <div id="notification-dropdown">
    <div id="notification-header">
      <h5 class="header-title"> Notifications </h5>
      <div id="notification-count"> {{ notificationsCount || 0 }} </div>
      <!-- seems odd to have an empty div -->
      <div class="empty-space"></div>
      <DxButton icon="trash"
                styling-mode="text"
                @click="hideAllNotifications"
      />
    </div>
    <div id="notifications-container" v-if="notificationsCount > 0">
      <NotificationCard v-for="notification in notifications"
                        :notification-id="notification.un_id"
                        :notification-message="notification.notification_message"
                        :notification-type="notification.notification_type"
                        :notification-visible="!notification.viewed"
                        :notification-content="notification.content"
      />
    </div>
    <div v-else id="no-notifications-message">
      No new notifications
    </div>
  </div>
</template>

<script setup>
  import NotificationCard from "@/components/base-components/header/NotificationCard.vue";
  import DxButton from "devextreme-vue/button";
  import { computed } from 'vue';
  import { useHeaderStore } from "@/stores/headerStore.js";

  const headerStore = useHeaderStore()
  const props = defineProps(['notifications'])

  const notificationsCount = computed(() => props.notifications.length)

  const hideAllNotifications = () => {
    for (const notification of props.notifications) {
      headerStore.hideNotification(notification.un_id)
    }
  }
</script>

<style scoped lang="scss">
  #notification-dropdown {
    min-width: 19rem;

    .header-title {
      margin: 0 0.3rem;
    }

    #notification-header {
      background-color: $white-normal;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0.1875rem 0 0.1875rem 0.9375rem;
    }

    #notification-count {
      background-color: red;
      font-weight: bold;
      color: white;
      padding: 0.0625rem 0.25rem;
      border-radius: 0.1875rem;
      font-size: 1rem;
    }

    .empty-space {
      flex-grow: 1
    }

    #notifications-container {
      max-height: 32rem;
      overflow-y: auto;
    }

    #no-notifications-message {
      width: 25rem;
      padding: 1.25rem 2.5rem 1.25rem 3rem;
      text-align: center;
      color: $gray-darkest;
    }
  }
</style>
